var uid = 0;
/** Get props to conform to OUIA spec
 *
 * @param {string} componentType OUIA component type
 * @param {number|string} id OUIA component id
 * @param {boolean} ouiaSafe false if in animation
 */

export function getOUIAProps(componentType, id) {
  var ouiaSafe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    'data-ouia-component-type': "PF4/".concat(componentType),
    'data-ouia-safe': ouiaSafe,
    'data-ouia-component-id': id === undefined ? uid++ : id
  };
}